import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppDispatcher from '../dispatcher/AppDispatcher';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { scrollElementIntoView } from '../utility/domUtils';

export class ServerErrors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
    };
  }
  componentDidMount() {
    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();
  }

  registerAppDispatcherMessages() {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (_get(payload, 'action.actionType') === 'UPDATE_SERVER_ERRORS') {
        let errorMessages = _get(payload, 'action.item.serverErrors', []);
        this.setState(
          {
            errorMessages,
          },
          () => {
            if (this.state.errorMessages.length > 0) {
              scrollElementIntoView('.service_error_holder');
            }
          }
        );
      }
    });
  }

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  render() {
    const { errorMessages } = this.state;
    if (_isEmpty(errorMessages)) {
      return null;
    }

    return (
      <div className="ppvx_col-sm-12 service_error_holder">
        {errorMessages.map((message, index) => {
          return (
            <div className="ppvx_row" key={message.key || index}>
              <div
                className="ppvx_alert ppvx_alert--type_error error-text"
                role="alert"
                dangerouslySetInnerHTML={{
                  __html: message.value,
                }}
              ></div>
            </div>
          );
        })}
      </div>
    );
  }
}

ServerErrors.propTypes = {
  errorMessages: PropTypes.array,
};

export default ServerErrors;
